import React, { useEffect, useState } from 'react';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';
import { useHistory, useLocation } from 'react-router-dom';

import { getQueryString } from '../../utils/utils';
import { PCStoreJsBridge } from '../../nativeapi';
import Loading from '../../components/Loading/Loading';
import { CONTEXT } from '../../config';
import { cacheKeys } from '../../constants/storageKeys';
import styles from './Setting.module.less';
import Download from './components/Download';
import Update from './components/Update';
import Individualization from './components/Individualization';
import Uninstall from './components/Uninstall';
import SetupItem from './components/SetupItem';
import WallpaperChange from './components/WallpaperChange';
import MessageHint from './components/MessageHint';
import UnknownFile from './components/UnknownFile';
import HighQuality from './components/HighQuality';
import RightMenu from './components/RightMenu';
import StoreTray from './components/StoreTray';

/*
1： 升级弹框，
2： 右键菜单开关， 
3： 卸载残留弹窗开关， 
4： 不常用软件弹窗开关,
5:  开启未知文件推荐设置,
6:  开启系统消息提醒,
7:  壁纸中心入口,
11：个性化推荐开关,
12: 优质内容推送
13: 右键评分更新控制
*/

function Setting() {
  // 是否打开右键菜单开关
  const [isDStore, setIsDStore] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
    // 是否为独立包
    setIsDStore(startInfo.isDStore || false);

    PCStoreJsBridge.getRightMenuInfo().then(res => {
      const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
      localStorage.setItem(
        cacheKeys.START_INFO,
        JSON.stringify({
          ...startInfo,
          rightMenuInfo: res.succ ? res : null,
        }),
      );
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    const more = getQueryString('more', location?.search);
    if (more === '1' && !isLoading) {
      const el = document.querySelector(`[id='more_setting']`);
      // history.replace(`${CONTEXT}/setting`);
      el && el.scrollIntoView({ block: 'start' });
    }
  }, [location, isLoading]);

  let startInfo = {};
  try {
    startInfo = JSON.parse(localStorage.getItem('START_INFO'));
  } catch (error) {}

  return (
    <div className={styles.s_page}>
      {isLoading && <Loading />}
      {!isLoading && (
        <div className="s_page_container">
          <div className="s_title">设置中心</div>
          <div className="s_select">
            <div className="s_small_title">下载设置</div>
            <Download />
          </div>
          {isDStore && (
            <div className="s_select">
              <div className="s_small_title">商店版本更新</div>
              <Update />
            </div>
          )}

          <div className="s_select">
            <div className="s_small_title">个性化推荐</div>
            <Individualization />
          </div>
          <div className="s_select">
            <div className="s_small_title" id="more_setting">
              更多设置
            </div>
            <Uninstall />
            <SetupItem />
            <WallpaperChange />
            <MessageHint />
            <HighQuality />
            {startInfo?.isDStore && <StoreTray />}
            <UnknownFile />
            <RightMenu />
          </div>
        </div>
      )}
    </div>
  );
}

export default () => (
  <KeepAlive>
    <Setting />
  </KeepAlive>
);
